import ViewLanguagesHome from "../views/ViewLanguagesHome.vue"

export default [
	{
		path: "/languages",
		component: ViewLanguagesHome,
		name: "ViewLanguagesHome",
		meta: {}
	}
]
